import _ from 'lodash';

import PropTypes from 'prop-types';

import { FadeInAnimation, Shapes } from '../../components/shared';

import Image from '../../components/shared/image.component';

import { parseTitle } from '../../../utils/title-parser';

import useResponsive from '../../../utils/responsive';

import { WordPressImageTransformer } from '../../../utils/wordpress-image-transformer';

const ChooseSection = (props) => {    
    const { isMobile, isTablet } = useResponsive();
    const { imgSrc, imgAlt, title, subHeading, paragraph, icons } = props;

    const renderImageSectionDesktop = () => {
        if (!isMobile || !isTablet) {
            const imgSrcDesktop = WordPressImageTransformer(imgSrc, 592, 100);
            return (
                <>
                    <Shapes
                        isPair
                        isDark
                        degrees="-45.67deg"
                        speed={0.07}
                        smallMargins={{ width: 50, height: 25 }}
                        largeMargins={{ width: 86, height: 43 }}
                        distanceBetween={{ width: '0%', height: '14%' }}
                        containerMargins={{ left: '82%', top: '5%' }}
                        zIndex={2}
                    />
                    <Image className='choose-section-choose-image' src={imgSrcDesktop} alt={imgAlt} isOldImage />
                </>
            );
        }
        return null;
    };

    const renderImageSectionMobile = () => {
        if (isMobile) {
            const imgSrcMobile = WordPressImageTransformer(imgSrc, 400, 100);
            return (
                <>
                    <Shapes
                        isPair
                        isDark
                        degrees="-45.67deg"
                        speed={0.07}
                        smallMargins={{ width: 25.33, height: 12.67 }}
                        largeMargins={{ width: 43.58, height: 21.79 }}
                        distanceBetween={{ width: '0%', height: '15%' }}
                        containerMargins={{ left: '85%', top: '8%' }}
                        zIndex={2}
                    />
                    <Image className='choose-section-choose-image' src={imgSrcMobile} alt={imgAlt} isOldImage />
                </>
            );
        }
        return null;
    };

    const renderImageSection = () => {
        return (
            <div className='hero-section-image-container'>
                {renderImageSectionDesktop()}
                {renderImageSectionMobile()}
            </div>
        );
    };

    const renderTextSection = () => {
        return (
            <FadeInAnimation>
                <div>
                    <h4>{subHeading}</h4>
                    <p className='choose-section-black-text-opacity'>{paragraph}</p>
                    {renderIcons()}
                </div>
            </FadeInAnimation>
        );
    };

    const renderIcons = () => {
        return icons.map((icon, index) => {
            const iconSrc = _.get(icon, 'icon_image.url');
            const iconTitle = _.get(icon, 'icon_title');
            const iconParagraph = _.get(icon, 'icon_paragraph');
            return (
                <div key={index} className='choose-section-icon-and-text-container'>

                    <div className='about-section-icon-container '>

                        <img src={iconSrc} alt="" className='about-section-icon-image ' />

                    </div>

                    <div>

                        <h5>{iconTitle}</h5>

                        <p className='about-section-dark-text-opacity'>{iconParagraph}</p>

                    </div>

                </div>
            );
        });
    };

    return (

        <div className='container-root container-root-maxWidthLg'>

            <div className='choose-section-main-heading-container'>{parseTitle(title, 'choose_header')}</div>

            <div className='main-grid-container main-grid-spacing-xs-3'>

                <div className='main-grid-item main-grid-lg-6 choose-section-image-container'>
                    {renderImageSection()}
                </div>

                <div className='main-grid-item main-grid-lg-6'>
                    {renderTextSection()}
                </div>

            </div>

        </div>

    );
};

export default ChooseSection;

ChooseSection.propTypes = {
    title: PropTypes.string,
    subHeading: PropTypes.string,
    paragraph: PropTypes.string,
    imgSrc: PropTypes.string,
    imgAlt: PropTypes.string,
    icons: PropTypes.array,
};

